import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FieldGroup } from '../../../libs/formLib';
import ButtonIcon from '../../common/ButtonIcon';
import { useNavigate } from 'react-router-dom';
import { animateScroll } from 'react-scroll';
import Select from 'react-select';

import { sumBy, isEmpty } from 'lodash';
import { useScheduling } from '../../../hooks/useScheduling';

import PropTypes from 'prop-types';
import {
  Row,
  Card,
  CardBody,
  FormGroup,
  Label,
  FormFeedback,
  Col,
  Button,
  TabContent,
  TabPane,
  Alert
} from 'reactstrap';
import SummaryModal from '../Vendor/Modal';
import CredsModal from '../Vendor/CredsModal';
import ExecutionStatsTab from '../section/ExecutionStatsTab';

import BZAPIService from '../../../services/BZAPIService';
import ProductPriority from '../section/ProductPriority';
import DefaultConfigTab from '../section/DefaultConfigTab';
import TabNav from '../section/TabNav';
import TabOne from '../section/TabOne';
import RiskScore from '../section/RiskScore';

// constants
import SETTINGS from '../../../constants/settings';
// import { active } from 'browser-sync';

// Cisco Contract Type Options
const CISCO_CONTRACT_TYPE_OPTIONS = [
  {
    label: 'Cisco Partner',
    value: 'ciscoPr',
    description: 'ServiceNow CMDB Inventory'
  },
  {
    label: 'Cisco CX (Coming Soon)',
    value: 'ciscoCx',
    description: 'Cisco CX support is coming soon',
    isDisabled: true
  }
];

const ConfigFormCisco = ({
  settings,
  vendor,
  isReadOnly,
  vendorLabel,
  vendorId,
  bugsDateBack,
  setBugsDateBack,
  vendorPriorityOptions,
  vendorStatusOptions,
  // vendorResolutionOptions,
  snIntegrationCheck,
  services,
  vendors,
  priorityStats,
  setPriorityStats,
  // bugOptions,
  snCompanySysIdOptions,
  snCompanySysIdErrors,
  setVendorStatuses,
  vendorStatuses,
  fields,
  handleFieldChange,
  priorityMaps,
  setPriorityMaps,
  snPriorityOptions,
  keywords,
  setKeywords,
  searchFields,
  setSearchFields,
  snCompanySysId,
  setSnCompanySysId,
  setServices,
  setVendors,
  buildVendorStat,
  setBugs,
  isConfigured,
  syncOnly,
  setSyncOnly,
  // supportCasesCount,
  // setCases,
  // isCasesOn,
  // setIsCasesOn,
  isCve,
  setIsCve,
  bugRisk,
  setBugRisk,
  loading,
  excludedComponents,
  setExcludedComponents,
  isServiceActive,
  setIsServiceActive,
  allRequired,
  setAllRequired,
  isUpdated,
  setIsUpdated,
  vendorContractType,
  setVendorContractType,
  vendorContractTypeOptions
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const [isValidCredentials, setIsValidCredentials] = useState(false);
  const [isTestingValidCredentials, setIsTestingValidCredentials] = useState(false);
  const [isAddingCredentials, setIsAddingCredentials] = useState(false);
  const [isUpdatingCreds, setIsUpdatingCreds] = useState(false);

  const [includedComponents, setIncludedComponents] = useState([]);
  // const [excludedComponents, setExcludedComponents] = useState([]);
  // const [searchFields, setSearchFields] = useState([]);
  const [loader, setLoader] = useState(false);

  const [riskError, setRiskError] = useState('');

  // const [priorityMaps, setPriorityMaps] = useState([]);

  // const snPriorityOptions = SERVICENOW.SN_PRIORITY_OPTIONS;

  // const [isCasesOn, setIsCasesOn] = useState(false);

  const [activeTab, setActiveTab] = useState('1');
  const [modalOpen, setModalOpen] = useState(false);
  const [validated, setValidated] = useState(null);

  const [query, setQuery] = useState('');
  const [offset, setOffset] = useState('0');
  const [limit, setLimit] = useState('2500');

  // const [isOpenTooltip, setIsOpenTooltip] = useState({});

  const [isForceRun, setIsForceRun] = useState(false);

  // Use scheduling hook for state and save function
  const {
    timeUnit,
    setTimeUnit,
    timeValue,
    setTimeValue,
    schedulingMode,
    setSchedulingMode,
    schedules,
    setSchedules,
    nextRun,
    setNextRun,
    saveBugServiceFrequency
  } = useScheduling();

  async function setBugServiceFrequency() {
    await saveBugServiceFrequency(vendorId);
  }

  async function onLoad() {
    setLoader(true);
    try {
      // No component exclusion: Cisco stopped returning a bug's component in September 2025 (STRY0038862).
      settings.searchFields
        ? setSearchFields(settings.searchFields)
        : setSearchFields(vendor?.vendorData?.searchFields);

      setLoader(false);
    } catch (e) {
      console.log(e);
      setLoader(false);
    }
  }

  useEffect(() => {
    onLoad();
    console.log('bug risk', bugRisk);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setIsUpdated(true);
    if (
      bugsDateBack?.length &&
      snCompanySysId?.value &&
      priorityMaps?.length &&
      !priorityMaps.some(mapping => !mapping.snPriority || !mapping.vendorPriority) &&
      vendorStatuses.length &&
      vendorContractType?.value &&
      (fields.supportSecretId ||
        (fields.supportClientId && fields.supportClientSecret && fields.cloudAppsUser && fields.cloudAppsPass))
    ) {
      setAllRequired(true);
    } else {
      setAllRequired(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    fields,
    bugsDateBack,
    priorityStats,
    vendorStatuses,
    priorityMaps,
    keywords,
    excludedComponents,
    isCve,
    searchFields,
    snCompanySysId,
    bugRisk,
    vendorContractType
  ]);

  async function testCreds() {
    setIsTestingValidCredentials(true);
    const data = {
      supportApiClientId: fields.supportClientId,
      supportApiClientSecret: fields.supportClientSecret,
      // serviceApiClientId: fields.serviceClientId,
      // serviceApiClientSecret: fields.serviceClientSecret,
      cloudAppsUser: fields.cloudAppsUser,
      cloudAppsPass: fields.cloudAppsPass
    };
    // console.log('data', data);
    const result = await BZAPIService.vendorTestCreds(vendorId, data);
    setIsTestingValidCredentials(false);
    if (result && result.completed) {
      // valid creds
      // console.log('result.active_iq_customers', result.active_iq_customers);
      fields.refreshToken = result.refresh_token;
      setIsValidCredentials(true);
      setIsAddingCredentials(false);
      setIsUpdatingCreds(true);
      toast.success(`Credentials validated.`);
    } else {
      toast.error(`Unable to validate credentials.`);
      setIsAddingCredentials(false);
    }

    console.log('result', result);
  }

  // async function saveServiceAWSSecret() {
  //   const data = {
  //     secret: {
  //       ClientId: fields.supportClientId,
  //       ClientSecret: fields.supportClientSecret
  //     },
  //     vendorId: 'cisco',
  //     key: 'serviceApi'
  //   };
  //   // service api secret
  //   return BZAPIService.createOrUpdateAWSSecret(data);
  // }

  async function saveSupportAWSSecret() {
    const data = {
      secret: {
        ClientId: fields.supportClientId,
        ClientSecret: fields.supportClientSecret
      },
      vendorId: 'cisco',
      key: 'supportApi'
    };

    // support api secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function saveCloudAppsAWSSecret() {
    const data = {
      secret: {
        username: fields.cloudAppsUser,
        password: fields.cloudAppsPass
      },
      vendorId: 'cisco',
      key: 'services-login'
    };
    // cloud apps secret
    return BZAPIService.createOrUpdateAWSSecret(data);
  }

  async function saveConfig(supportSecret, cloudLoginId) {
    // save client config
    const vendorPriorities = priorityMaps.map(mapping => {
      return {
        value: mapping.vendorPriority.value,
        label: mapping.vendorPriority.value,
        snPriority: mapping.snPriority.value
      };
    });

    const data = {
      bugsDateBack: bugsDateBack,
      // serviceSecretId: serviceSecret.Name,
      supportSecretId: supportSecret.Name,
      cloudLoginId: cloudLoginId.Name,
      snCompanySysId: snCompanySysId.value ? snCompanySysId.value : fields.snCompanySysId,
      snAffectedCIQuery: fields.snAffectedCIQuery,
      vendorPriorities,
      vendorStatuses,
      type: SETTINGS.VENDOR,
      excludedKws: keywords,
      searchFields: searchFields,
      filterCVEs: isCve,
      // supportCasesCount: isCasesOn ? supportCasesCount : 0,
      bugRiskScore: bugRisk,
      vendorContractType: vendorContractType
    };

    return BZAPIService.saveSetting(vendorId, syncOnly, data, isForceRun, isUpdatingCreds);
  }

  async function handleSave() {
    setRiskError('');
    try {
      setIsSubmitted(true);
      setIsLoading(true);
      // Check if Credentials test is complete
      if (!isValidCredentials && !fields.cloudLoginId) {
        console.log('Validated Credentials', isValidCredentials);
        toast.error('Credentials Test Missing.');
        setValidated(false);
        setActiveTab('2');
        setIsLoading(false);
        return;
      }
      // Validate Cisco Client Type
      if (!vendorContractType?.value) {
        console.log('Cisco Client Type not selected');
        toast.error('Please select a Cisco Client Type.');
        setValidated(false);
        setActiveTab('2');
        setIsLoading(false);
        return;
      }
      // Validate
      if (!bugsDateBack.length || !snCompanySysId) {
        console.log('failed validation');
        setValidated(false);
        setActiveTab('3');
        setIsLoading(false);
        return;
      }
      // Validate status
      if (
        !vendorStatuses.length ||
        !priorityMaps.filter(mapping => {
          return mapping.vendorPriority.value && mapping.snPriority.value;
        }).length
      ) {
        setValidated(false);
        setActiveTab('4');
        setIsLoading(false);
        return;
      }
      // Validate Secrets

      if (!fields.supportSecretId) {
        if (
          // !fields.serviceClientId ||
          // !fields.serviceClientSecret ||
          !fields.supportClientId ||
          !fields.supportClientSecret ||
          !fields.cloudAppsUser ||
          !fields.cloudAppsPass
        ) {
          console.log('misisng secret');
          setValidated(false);
          setIsLoading(false);
          setActiveTab('2');
          return;
        }
      }

      // Validate Risk Score
      const activeRisk = bugRisk.filter(y => {
        return y.active;
      });
      const activeSum = sumBy(activeRisk, risk => {
        return risk.value;
      });

      if (activeSum < 100 && activeSum > 1) {
        console.log('Bug risk share is less than 100');
        setValidated(false);
        setIsLoading(false);
        setActiveTab('5');
        setRiskError('Bug risk share total must be 100');
        return;
      }

      let supportSecret, cloudLoginId;

      if (
        // fields.serviceClientSecret &&
        // fields.serviceClientId &&
        fields.supportClientId &&
        fields.supportClientSecret &&
        fields.cloudAppsUser &&
        fields.cloudAppsPass
      ) {
        // Updated secrets
        // serviceSecret = await saveServiceAWSSecret();
        supportSecret = await saveSupportAWSSecret();
        cloudLoginId = await saveCloudAppsAWSSecret();
      } else {
        // use existing secrets
        // serviceSecret = { Name: fields.serviceSecretId };
        supportSecret = { Name: fields.supportSecretId };
        cloudLoginId = { Name: fields.cloudLoginId };
      }

      // validate priority maps
      let validPriorities = true;
      priorityMaps.map(item => {
        if (!item.vendorPriority || !item.snPriority) validPriorities = false;
        return item;
      });
      if (!validPriorities) {
        console.log('Invalid priorities');
        setValidated(false);
        setIsLoading(false);
        return false;
      }

      await saveConfig(supportSecret, cloudLoginId);
      // set updated secretId
      // fields.serviceSecretId = serviceSecret.Name;
      fields.supportSecretId = supportSecret.Name;
      fields.cloudLoginId = cloudLoginId.Name;
      setBugServiceFrequency();
      setIsLoading(false);
      setIsSubmitted(false);
      setModalOpen(false);
      setIsForceRun(false);
      setIsUpdatingCreds(false);
      setActiveTab('1');
      toast.success(`Settings Saved!`);
    } catch (e) {
      setIsLoading(false);
      toast.error('Failed to save.');
      console.log('e', e);
    }
  }

  function handleValidationError() {
    setModalOpen(!modalOpen);
    animateScroll.scrollTo(70);
  }

  return (
    <>
      <TabNav
        vendorId={vendorId}
        credentials={true}
        activeTab={activeTab}
        snIntegrationCheck={snIntegrationCheck}
        setActiveTab={setActiveTab}
        setIsLoading={setIsLoading}
        isLoading={isLoading}
        setServices={setServices}
        setVendors={setVendors}
        buildVendorStat={buildVendorStat}
        setPriorityStats={setPriorityStats}
        setBugs={setBugs}
        isConfigured={isConfigured}
        hasBugRisk={true}
        loading={loading}
      />

      <TabContent>
        <TabOne
          vendorId={vendorId}
          vendorLabel={vendorLabel}
          activeTab={activeTab}
          setActiveTab={setActiveTab}
          snIntegrationCheck={snIntegrationCheck}
          services={services}
          vendors={vendors}
          priorityStats={priorityStats}
          isConfigured={isConfigured}
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          setIsForceRun={setIsForceRun}
          timeUnit={timeUnit}
          setTimeUnit={setTimeUnit}
          timeValue={timeValue}
          setTimeValue={setTimeValue}
          schedulingMode={schedulingMode}
          setSchedulingMode={setSchedulingMode}
          schedules={schedules}
          setSchedules={setSchedules}
          nextRun={nextRun}
          setNextRun={setNextRun}
          loading={loading}
          isServiceActive={isServiceActive}
          setIsServiceActive={setIsServiceActive}
        />

        <form noValidate style={{ minWidth: '100%' }}>
          <TabPane tabId="2">
            {activeTab === '2' && (
              // <input type="hidden" value="prayer" />
              <Card bg={'light'} text={'dak'} className="mb-4">
                {/* <FalconCardHeader title="Vendor settings" /> */}
                <CardBody>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Cisco API Credentials
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        {!isAddingCredentials ? (
                          <>
                            <div className="d-flex align-items-center">
                              <ButtonIcon
                                onClick={() => setIsAddingCredentials(true)}
                                color="falcon-default"
                                data-testid={'cisco-set-credentials-btn'}
                                size="sm"
                                icon="plus"
                                iconClassName="fs--2"
                              >
                                Set Credentials
                              </ButtonIcon>

                              {fields.supportSecretId || isValidCredentials ? (
                                <div className="d-flex align-items-center" data-testid={'sn-creds-stored-message'}>
                                  {'  '}
                                  <FontAwesomeIcon icon={'check'} style={{ color: 'green', marginLeft: '10px' }} />{' '}
                                  Cisco API Credentials Stored
                                </div>
                              ) : null}
                            </div>
                          </>
                        ) : (
                          <>
                            {/* <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="serviceClientId"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.serviceClientId}
                                  label={'Service API Client ID'}
                                  data-testid={'cisco-service-id'}
                                  showFeedback={!fields.serviceClientId && isSubmitted}
                                  feedback={'Please specify a service client id.'}
                                  placeholder="Enter service api client id"
                                  // style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="serviceClientSecret"
                                  id="serviceClientSecret"
                                  label={'Service API Client Secret'}
                                  data-testid={'cisco-service-secret'}
                                  autoComplete="new-serviceClientSecret"
                                  placeholder="Enter service api client secret"
                                  onChange={handleFieldChange}
                                  value={fields.serviceClientSecret}
                                  showFeedback={!fields.serviceClientSecret && isSubmitted}
                                  feedback={'Please specify a service api client secret.'}
                                  required
                                />
                              </Col>
                            </Row> */}
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="supportClientId"
                                  autoComplete="new-password"
                                  onChange={handleFieldChange}
                                  value={fields.supportClientId}
                                  label={'Support API Client ID'}
                                  data-testid={'cisco-support-id'}
                                  showFeedback={!fields.supportClientId && isSubmitted}
                                  feedback={'Please specify a support client id.'}
                                  placeholder="Enter support api client id"
                                  // style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col>
                                <FieldGroup
                                  type="supportClientSecret"
                                  id="supportClientSecret"
                                  label={'Support API Client Secret'}
                                  data-testid={'cisco-support-secret'}
                                  autoComplete="new-supportClientSecret"
                                  placeholder="Enter support api client secret"
                                  onChange={handleFieldChange}
                                  value={fields.supportClientSecret}
                                  showFeedback={!fields.supportClientSecret && isSubmitted}
                                  feedback={'Please specify a support api client secret.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="6">
                                <FieldGroup
                                  type="text"
                                  id="cloudAppsUser"
                                  autoComplete="new-cloudAppsUser"
                                  onChange={handleFieldChange}
                                  value={fields.cloudAppsUser}
                                  label={'cisco.com Username'}
                                  data-testid={'cisco-cloud-username'}
                                  showFeedback={!fields.cloudAppsUser && isSubmitted}
                                  feedback={'Please specify a Cloud App Username.'}
                                  placeholder="Enter Cloud App username"
                                  // style={{ marginBottom: '10px' }}
                                  required
                                />
                              </Col>
                              <Col lg="6">
                                <FieldGroup
                                  type="cloudAppsPass"
                                  id="cloudAppsPass"
                                  label={'cisco.com Password'}
                                  data-testid={'cisco-cloud-password'}
                                  autoComplete="new-cloudAppsPass"
                                  placeholder="Enter Cloud App password"
                                  onChange={handleFieldChange}
                                  value={fields.cloudAppsPass}
                                  showFeedback={!fields.cloudAppsPass && isSubmitted}
                                  feedback={'Please specify a Cloud App Password.'}
                                  required
                                />
                              </Col>
                            </Row>
                            <CredsModal
                              isTestingValidCredentials={isTestingValidCredentials}
                              setIsTestingCredentials={setIsTestingValidCredentials}
                              fields={fields}
                              testCreds={testCreds}
                              vendorId={vendorId}
                            />
                            <ButtonIcon
                              onClick={() => setIsAddingCredentials(false)}
                              color="falcon-default"
                              size="sm"
                              icon="times"
                              iconClassName="fs--2"
                              style={{ marginRight: '10px' }}
                              data-testid={'cisco-cancel-creds-btn'}
                            >
                              Cancel
                            </ButtonIcon>
                          </>
                        )}
                        <FormFeedback
                          className={
                            // !fields.serviceSecretId &&
                            // !fields.supportSecretId &&
                            // !fields.serviceClientId &&
                            // !fields.serviceClientSecret &&
                            !fields.supportClientId &&
                            !fields.supportClientSecret &&
                            !fields.cloudAppsPass &&
                            !fields.cloudAppsUser &&
                            isSubmitted
                              ? 'd-block'
                              : ''
                          }
                          type="invalid"
                        >
                          <Alert color="danger">Please specify credentials.</Alert>
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row form>
                    <Col lg="12">
                      <FormGroup>
                        <Label>
                          Cisco Client Type
                          <span style={{ color: '#bd472a' }}>*</span>
                        </Label>
                        <Select
                          id="cisco-client-type"
                          name="cisco-client-type"
                          value={vendorContractType}
                          onChange={e => setVendorContractType(e)}
                          options={CISCO_CONTRACT_TYPE_OPTIONS}
                          isOptionDisabled={option => option.isDisabled}
                          getOptionLabel={option => (isEmpty(option) ? 'Select...' : option.label)}
                          theme={theme => ({
                            ...theme,
                            borderRadius: 5,
                            colors: {
                              ...theme.colors,
                              text: 'white',
                              primary25: '#253746',
                              primary: '#bd472a',
                              neutral10: '#bd472a',
                              dangerLight: '#bf6e4c'
                            }
                          })}
                          styles={{
                            option: (styles, { isDisabled, isFocused, isSelected }) => {
                              return {
                                ...styles,
                                color: isFocused ? 'white' : isSelected ? 'white' : 'black'
                              };
                            }
                          }}
                          data-testid={'cisco-client-type-select'}
                        />
                        <FormFeedback
                          className={isSubmitted && !vendorContractType?.value ? 'd-block' : ''}
                          type="invalid"
                          data-testid={'cisco-client-type-feedback'}
                        >
                          <Alert color="danger">Please select a Cisco Client Type.</Alert>
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            )}
          </TabPane>
          <DefaultConfigTab
            vendor={vendor}
            activeTab={activeTab}
            vendorLabel={vendorLabel}
            bugsDateBack={bugsDateBack}
            setBugsDateBack={setBugsDateBack}
            isSubmitted={isSubmitted}
            snCompanySysIdErrors={snCompanySysIdErrors}
            snCompanySysIdOptions={snCompanySysIdOptions}
            setSnCompanySysId={setSnCompanySysId}
            snCompanySysId={snCompanySysId}
            fields={fields}
            handleFieldChange={handleFieldChange}
          />
          <TabPane tabId="4">
            {activeTab === '4' && (
              <ProductPriority
                title="Default Bug Configuration"
                vendorId={vendorId}
                vendorPriorityOptions={vendorPriorityOptions}
                vendorStatusOptions={vendorStatusOptions}
                setVendorStatuses={setVendorStatuses}
                vendorStatuses={vendorStatuses}
                isSubmitted={isSubmitted}
                priorityMaps={priorityMaps}
                setPriorityMaps={setPriorityMaps}
                snPriorityOptions={snPriorityOptions}
                keywords={keywords}
                setKeywords={setKeywords}
                includedComponents={includedComponents}
                setIncludedComponents={setIncludedComponents}
                excludedComponents={excludedComponents}
                setExcludedComponents={setExcludedComponents}
                searchFields={searchFields}
                setSearchFields={setSearchFields}
                vendorLabel={vendorLabel}
                setLoader={setLoader}
                setQuery={setQuery}
                query={query}
                offset={offset}
                limit={limit}
                setOffset={setOffset}
                setLimit={setLimit}
                loader={loader}
                isCve={isCve}
                setIsCve={setIsCve}
                // supportCasesCount={supportCasesCount}
                // setCases={setCases}
                // isCasesOn={isCasesOn}
                // setIsCasesOn={setIsCasesOn}
              />
            )}
          </TabPane>
          <div style={{ minWidth: '100%' }}>
            <TabPane tabId="5">
              {activeTab === '5' && <RiskScore bugRisk={bugRisk} setBugRisk={setBugRisk} riskError={riskError} />}
            </TabPane>
          </div>
          <TabPane tabId="6">{activeTab === '6' && <ExecutionStatsTab vendorId={vendorId} />}</TabPane>

          <Row className={`${activeTab === '1' ? 'd-none' : ''} flex-between-center`}>
            <Col xs="auto">
              <Button
                block
                color="falcon-danger"
                onClick={() => {
                  console.log(`/vendors/${vendorId}/configuration`);
                  navigate(-1);
                }}
              >
                Cancel
              </Button>
            </Col>
            <Col xs="auto">
              <SummaryModal
                modalOpen={modalOpen}
                isReadOnly={isReadOnly}
                setModalOpen={setModalOpen}
                handleSave={handleSave}
                isLoading={isLoading}
                vendorLabel={vendorLabel?.replace('Systems', 'Networks')}
                vendorId={vendorId}
                validated={validated}
                setValidated={setValidated}
                syncOnly={syncOnly}
                setSyncOnly={setSyncOnly}
                handleValidationError={handleValidationError}
                allRequired={allRequired}
                isUpdated={isUpdated}
              />
            </Col>
          </Row>
        </form>
      </TabContent>
    </>
  );
};
ConfigFormCisco.propTypes = {
  vendorLabel: PropTypes.string,
  vendorId: PropTypes.string,
  vendorPriorityOptions: PropTypes.array,
  vendorStatusOptions: PropTypes.array,
  vendorResolutionOptions: PropTypes.array,
  snCompanySysIdOptions: PropTypes.object,
  snCompanySysId: PropTypes.object,
  snIntegrationCheck: PropTypes.bool,
  services: PropTypes.array,
  vendors: PropTypes.array,
  bugs: PropTypes.object,
  priorityStats: PropTypes.object,
  setPriorityStats: PropTypes.func,
  bugOptions: PropTypes.array,
  selectedBugOption: PropTypes.object,
  setSelectedBugOption: PropTypes.func,
  snCompanySysIdErrors: PropTypes.bool,
  vendorEventScopes: PropTypes.array,
  setVendorEventScopes: PropTypes.func,
  vendorResolutions: PropTypes.array,
  setVendorResolutions: PropTypes.func,
  setVendorStatuses: PropTypes.func,
  vendorStatuses: PropTypes.array,
  fields: PropTypes.object,
  handleFieldChange: PropTypes.func,
  priorityMaps: PropTypes.array,
  setPriorityMaps: PropTypes.func,
  snPriorityOptions: PropTypes.array,
  keywords: PropTypes.array,
  setKeywords: PropTypes.func,
  searchFields: PropTypes.array,
  setSearchFields: PropTypes.func,
  setSnCompanySysId: PropTypes.func,
  vendor: PropTypes.object,
  isReadOnly: PropTypes.bool,
  settings: PropTypes.object,
  bugsDateBack: PropTypes.string,
  setBugsDateBack: PropTypes.func,
  setServices: PropTypes.func,
  setVendors: PropTypes.func,
  buildVendorStat: PropTypes.func,
  setBugs: PropTypes.func,
  isConfigured: PropTypes.bool,
  syncOnly: PropTypes.bool,
  setSyncOnly: PropTypes.func,
  // supportCasesCount: PropTypes.number,
  // setCases: PropTypes.func,
  // isCasesOn: PropTypes.bool,
  // setIsCasesOn: PropTypes.func,
  isCve: PropTypes.bool,
  setIsCve: PropTypes.func,
  bugRisk: PropTypes.array,
  setBugRisk: PropTypes.func,
  loading: PropTypes.bool,
  excludedComponents: PropTypes.array,
  setExcludedComponents: PropTypes.func,
  setIsServiceActive: PropTypes.func,
  isServiceActive: PropTypes.number,
  allRequired: PropTypes.bool,
  isUpdated: PropTypes.bool,
  setAllRequired: PropTypes.func,
  setIsUpdated: PropTypes.func,
  vendorContractType: PropTypes.object,
  setVendorContractType: PropTypes.func,
  vendorContractTypeOptions: PropTypes.array
};
export default ConfigFormCisco;
